<div *ngIf="toastMessage" class="toast {{ toastType }}">
  {{ toastMessage }}
</div>